import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  iconName, 
  trend, 
  trendValue, 
  status = 'neutral',
  onClick 
}) => {
  const statusColors = {
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    danger: 'bg-error/10 text-error border-error/20',
    neutral: 'bg-muted text-foreground border-border'
  };

  const trendColors = {
    up: 'text-success',
    down: 'text-error',
    neutral: 'text-muted-foreground'
  };

  return (
    <div 
      className={`bg-card border rounded-lg p-4 md:p-6 transition-smooth hover:elevation-2 ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <p className="caption text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground data-text">
            {value}
          </h3>
          {subtitle && (
            <p className="text-xs md:text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${statusColors?.[status]}`}>
          <Icon name={iconName} size={20} />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-2 mt-3 pt-3 border-t border-border">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={trendColors?.[trend]}
          />
          <span className={`text-xs md:text-sm font-medium ${trendColors?.[trend]}`}>
            {trendValue}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;